import debug from 'debug';

// Define different namespaces for different log types
const log = debug('ti:log');
const error = debug('ti:error');

// Export the log functions as default
/**
 * @typedef {Object} Logger
 * @property {function(...*): void} log
 * @property {function(...*): void} error
 */

/**
 * @type {Logger}
 */
export const logger = {
    log: (...args) => {
        log(...args);
    },
    error: (...args) => {
        error(...args);
    },
};
